import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Redirect, Route, Switch, withRouter,
} from 'react-router-dom';
import {
  always,
  complement,
  compose,
  difference,
  head,
  includes,
  keys,
  last,
  map,
  path,
  split,
  when,
  __,
} from 'ramda';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import applicationPropType from './applicationPropType';
import GeneralInfo from './GeneralInfo';
import Tokens from './Tokens';
import Auth from './Auth';
import OAuth20 from './OAuth20';
import Tokens20 from './Tokens20';
import Transfer from './Transfer';
import { capitalize } from '../../utils';
import Users from './Users';
import Register from './Register'

const lastPathSegment = compose(last, split('/'), path(['location', 'pathname']));

const tabs = {
  general: GeneralInfo,
  'oauth 2': OAuth20,
  'oauth 2 tokens': Tokens20,
  auth: Auth,
  tokens: Tokens,
  notifications: Register,
  users: Users,
  transfer: Transfer,
};

const selectedTabForUrl = compose(
  when(complement(includes(__, keys(tabs))), always(head(keys(tabs)))),
  lastPathSegment,
);


const ApplicationSettings = withRouter(({
  match,
  history,
  omitTabs,
  refreshApp,
  ownerId,
  ...rest
}) => (
  <Fragment>
    <Tabs
      value={selectedTabForUrl(history)}
      style={{ marginBottom: '0.5em' }}
      indicatorColor="primary"
      textColor="primary"
      scrollable
      scrollButtons="auto"
    >
      {map(tab => (
        <Tab
          key={tab}
          value={tab}
          label={capitalize(tab)}
          onClick={() => history.push(`${match.url}/${tab}`)}
        />
      ), difference(keys(tabs), omitTabs))}
    </Tabs>
    <Switch>
      <Route path={match.url} exact render={props => <Redirect to={`${match.url}/general`} {...props} />} />
      {map(tab => (
        <Route
          key={tab}
          path={`${match.url}/${tab}`}
          exact
          render={() => {
            const Component = tabs[tab];
            return (<Component refreshApp={refreshApp} ownerId={ownerId} {...rest} />);
          }}
        />
      ), difference(keys(tabs), omitTabs))}
    </Switch>
  </Fragment>
));

ApplicationSettings.propTypes = {
  application: applicationPropType.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  omitTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  refreshApp: PropTypes.func.isRequired,
};

ApplicationSettings.defaultProps = {
  omitTabs: [],
};

export default ApplicationSettings;
